"use client";
import { jsx } from "react/jsx-runtime";
import { addToListActions } from "../../constants.js";
import { ProductSimple } from "../../../ProductSimple/index.js";
const ProductUI = (props) => {
  var _a;
  const {
    dispatch,
    msStore,
    product,
    state,
    showQuantity = false,
    showQuantitySelector = true
  } = props;
  const { quantity } = state;
  const quantityerrormessage = msStore.getKeyValueItem(
    "wishlistquantityerrormessage"
  );
  const parsedProductTitle = (product.title || "").replace(/\./g, "");
  return /* @__PURE__ */ jsx(
    ProductSimple,
    {
      onQuantityChange: (val) => dispatch({
        payload: { quantity: val },
        type: addToListActions.UPDATE_QUANTITY
      }),
      showProductAttributes: ((_a = state == null ? void 0 : state.productAttributes) == null ? void 0 : _a.length) ? true : false,
      customErrorMsg: !quantity ? quantityerrormessage : "",
      drawerItem: true,
      hideImageFromAccessibility: true,
      id: product.id,
      price: product.price,
      productAttributes: state.productAttributes,
      quantity,
      currentQuantity: +quantity || void 0,
      showQuantity,
      showQuantitySelector,
      src: product.src,
      title: parsedProductTitle
    }
  );
};
export {
  ProductUI
};
